import { omit } from 'lodash';

import {
  GET_MEAL_REVIEW_STATS_V3_REQUEST,
  GET_MEAL_REVIEW_STATS_V3_RESPONSE,
  GET_MEAL_REVIEW_STATS_V3_ERROR,
} from 'lib/constants/v3Actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MEAL_REVIEW_STATS_V3_REQUEST: {
      const { mealId, menuSlug } = action.params;

      return {
        ...state,
        [menuSlug]: {
          ...state[menuSlug],
          [mealId]: {
            isError: false,
            isLoading: true,
          },
        },
      };
    }
    case GET_MEAL_REVIEW_STATS_V3_RESPONSE: {
      const response = omit(action.response, ['ok', 'status']);
      const { mealId, menuSlug } = action.params;

      return {
        ...state,
        [menuSlug]: {
          ...state[menuSlug],
          [mealId]: {
            isFetched: true,
            isLoading: false,
            isError: false,
            stats: Object.keys(response).length ? response : null,
          },
        },
      };
    }
    case GET_MEAL_REVIEW_STATS_V3_ERROR: {
      const { mealId, menuSlug } = action.params;

      return {
        ...state,
        [menuSlug]: {
          ...state[menuSlug],
          [mealId]: {
            isError: true,
            isLoading: false,
          },
        },
      };
    }
    default:
      return state;
  }
};
